module.exports = __webpack_public_path__ + "img/symbol_2.9506871e.png";